import { FC, useRef } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import JoditEditor from 'jodit-react';

import { WYSIWYG_OPTIONS } from './jodit-editor-input.constants';
import { JoditEditorWrapper } from './jodit-editor-input.styles';
import { IJoditEditorProps } from './jodit-editor-input.interfaces';

const JoinEditorInput: FC<IJoditEditorProps> = ({ onChange, value }) => {
  const editor = useRef(null);
  const { t } = useTranslation('settings');

  const config = {
    ...WYSIWYG_OPTIONS,
    placeholder: t('emailTemplate.labels.startWriting'),
    language: i18n.language,
    tabIndex: 1,
    minHeight: 300,
    className: 'jodit-editor-custom',
    showPlaceholder: true,
    hidePoweredByJodit: true,
    uploader: {
      insertImageAsBase64URI: true,
    },
  };

  return (
    <JoditEditorWrapper>
      <JoditEditor
        ref={editor}
        onBlur={newContent => {
          if (onChange) {
            onChange(newContent);
          }
        }}
        value={value}
        config={config}
      />
    </JoditEditorWrapper>
  );
};

export default JoinEditorInput;
